var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "ConfirmationModal",
    {
      attrs: {
        entity: _vm.ringTree,
        title: _vm.$t("DELETE_PING_TREE_MODAL_TITLE"),
        "confirm-action-text": _vm.$t("DELETE"),
        "cancel-button-text": _vm.$t("CANCEL"),
        "confirm-button-loading": _vm.loadingDeletingRingTree,
        "show-cancel-button": _vm.showActions,
        "show-confirm-button": _vm.showActions
      },
      on: { confirm: _vm.confirmDelete, close: _vm.closeDeleteModal }
    },
    [
      !_vm.ringTreeReferences && _vm.loadingRingTreeReferences
        ? _c(
            "div",
            [
              _c("Loader", { attrs: { "custom-class": "size-sm" } }),
              _vm._v(" "),
              _c("span", {
                domProps: {
                  innerHTML: _vm._s(
                    _vm.$t(_vm.checkReferencesText, {
                      pingTreeName: _vm.ringTree.name
                    })
                  )
                }
              })
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.ringTreeReferences && !_vm.hasReferences
        ? _c("p", {
            domProps: {
              innerHTML: _vm._s(
                _vm.$t("DELETE_PING_TREE_MODAL_NONE_ASSOCIATION_TEXT", {
                  pingTreeName: _vm.ringTree.name
                })
              )
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.ringTreeReferences && _vm.hasReferences
        ? _c("div", [
            _c("p", {
              domProps: {
                innerHTML: _vm._s(
                  _vm.$t("DELETE_PING_TREE_MODAL_ASSOCIATION_TEXT", {
                    pingTreeName: _vm.ringTree.name
                  })
                )
              }
            }),
            _vm._v(" "),
            _c("div", { staticClass: "well well-sm m-t-10 m-b-0" }, [
              _c("div", { staticClass: "form-horizontal" }, [
                _vm.ringTreeReferences.campaigns &&
                _vm.ringTreeReferences.campaigns.length > 0
                  ? _c("div", { staticClass: "row" }, [
                      _c("label", { staticClass: "col-md-3 control-label" }, [
                        _c("strong", [_vm._v("Campaigns")])
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "col-md-8" }, [
                        _c(
                          "ul",
                          {
                            staticClass:
                              "list-unstyled form-control-static list-text-overflow"
                          },
                          _vm._l(_vm.ringTreeReferences.campaigns, function(
                            campaign
                          ) {
                            return _c("li", { key: campaign.campaignId }, [
                              _c(
                                "a",
                                {
                                  directives: [
                                    {
                                      name: "tooltip",
                                      rawName: "v-tooltip.right.hover",
                                      value: _vm.$t("VIEW_CAMPAIGN"),
                                      expression: "$t('VIEW_CAMPAIGN')",
                                      modifiers: { right: true, hover: true }
                                    }
                                  ],
                                  attrs: {
                                    href: `#/dashboard/campaign/${campaign.campaignId}`,
                                    target: "_blank"
                                  }
                                },
                                [
                                  _c(
                                    "span",
                                    {
                                      staticClass: "display-text",
                                      attrs: { title: campaign.campaignName }
                                    },
                                    [
                                      _vm._v(
                                        "\n\t\t\t\t\t\t\t\t\t\t" +
                                          _vm._s(campaign.campaignName) +
                                          "\n\t\t\t\t\t\t\t\t\t"
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c("i", {
                                    staticClass: "fa fa-external-link m-l-5"
                                  })
                                ]
                              )
                            ])
                          }),
                          0
                        )
                      ])
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.ringTreeReferences.pingtreetargets &&
                _vm.ringTreeReferences.pingtreetargets.length > 0
                  ? _c("div", { staticClass: "row" }, [
                      _c("label", { staticClass: "col-md-3 control-label" }, [
                        _c("strong", [_vm._v("Ring Tree Targets")])
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "col-md-8" }, [
                        _c(
                          "ul",
                          {
                            staticClass:
                              "list-unstyled form-control-static list-text-overflow"
                          },
                          _vm._l(
                            _vm.ringTreeReferences.pingtreetargets,
                            function(pingtreetarget) {
                              return _c(
                                "li",
                                { key: pingtreetarget.pingtreetargetId },
                                [
                                  _c(
                                    "a",
                                    {
                                      directives: [
                                        {
                                          name: "tooltip",
                                          rawName: "v-tooltip.right.hover",
                                          value: _vm.$t(
                                            "DELETE_PING_TREE_MODAL_VIEW_TARGET"
                                          ),
                                          expression:
                                            "\n\t\t\t\t\t\t\t\t\t\t$t('DELETE_PING_TREE_MODAL_VIEW_TARGET')\n\t\t\t\t\t\t\t\t\t",
                                          modifiers: {
                                            right: true,
                                            hover: true
                                          }
                                        }
                                      ],
                                      attrs: {
                                        href: `#/dashboard/ringtreetarget/edit/${pingtreetarget.pingtreetargetId}`,
                                        target: "_blank"
                                      }
                                    },
                                    [
                                      _c(
                                        "span",
                                        {
                                          staticClass: "display-text",
                                          attrs: {
                                            title:
                                              pingtreetarget.pingtreetargetName
                                          }
                                        },
                                        [
                                          _vm._v(
                                            "\n\t\t\t\t\t\t\t\t\t\t" +
                                              _vm._s(
                                                pingtreetarget.pingtreetargetName
                                              ) +
                                              "\n\t\t\t\t\t\t\t\t\t"
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c("i", {
                                        staticClass: "fa fa-external-link m-l-5"
                                      })
                                    ]
                                  )
                                ]
                              )
                            }
                          ),
                          0
                        )
                      ])
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.ringTreeReferences.callplans &&
                _vm.ringTreeReferences.callplans.length > 0
                  ? _c("div", { staticClass: "row" }, [
                      _c("label", { staticClass: "col-md-3 control-label" }, [
                        _c("strong", [_vm._v("Routing Plans")])
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "col-md-8" }, [
                        _c(
                          "ul",
                          {
                            staticClass:
                              "list-unstyled form-control-static list-text-overflow"
                          },
                          _vm._l(_vm.ringTreeReferences.callplans, function(
                            callplan
                          ) {
                            return _c("li", { key: callplan.callplanId }, [
                              _c(
                                "span",
                                {
                                  staticClass: "display-text",
                                  attrs: { title: callplan.callplanName }
                                },
                                [
                                  _vm._v(
                                    "\n\t\t\t\t\t\t\t\t\t" +
                                      _vm._s(callplan.callplanName) +
                                      "\n\n\t\t\t\t\t\t\t\t\t"
                                  ),
                                  callplan.callplanNoRoutes
                                    ? _c("i", {
                                        directives: [
                                          {
                                            name: "tooltip",
                                            rawName: "v-tooltip.right.hover",
                                            value: _vm.$t(
                                              "NO_ROUTE_SETUP_WARNING_PING_TREE"
                                            ),
                                            expression:
                                              "\n\t\t\t\t\t\t\t\t\t\t\t$t('NO_ROUTE_SETUP_WARNING_PING_TREE')\n\t\t\t\t\t\t\t\t\t\t",
                                            modifiers: {
                                              right: true,
                                              hover: true
                                            }
                                          }
                                        ],
                                        staticClass:
                                          "fa fa-exclamation-circle text-danger f-s-14 m-l-5"
                                      })
                                    : _vm._e()
                                ]
                              )
                            ])
                          }),
                          0
                        )
                      ])
                    ])
                  : _vm._e()
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "form-horizontal m-l-10 m-r-10" }, [
              _c("div", { staticClass: "checkbox" }, [
                _c("label", [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.forceUnlink,
                        expression: "forceUnlink"
                      }
                    ],
                    attrs: { type: "checkbox" },
                    domProps: {
                      checked: Array.isArray(_vm.forceUnlink)
                        ? _vm._i(_vm.forceUnlink, null) > -1
                        : _vm.forceUnlink
                    },
                    on: {
                      change: [
                        function($event) {
                          var $$a = _vm.forceUnlink,
                            $$el = $event.target,
                            $$c = $$el.checked ? true : false
                          if (Array.isArray($$a)) {
                            var $$v = null,
                              $$i = _vm._i($$a, $$v)
                            if ($$el.checked) {
                              $$i < 0 && (_vm.forceUnlink = $$a.concat([$$v]))
                            } else {
                              $$i > -1 &&
                                (_vm.forceUnlink = $$a
                                  .slice(0, $$i)
                                  .concat($$a.slice($$i + 1)))
                            }
                          } else {
                            _vm.forceUnlink = $$c
                          }
                        },
                        _vm.setForceUnlink
                      ]
                    }
                  }),
                  _vm._v(" "),
                  _c("span", {
                    directives: [
                      {
                        name: "t",
                        rawName: "v-t",
                        value: "DELETE_PING_TREE_MODAL_CHECKBOX",
                        expression: "'DELETE_PING_TREE_MODAL_CHECKBOX'"
                      }
                    ]
                  })
                ])
              ])
            ])
          ])
        : _vm._e()
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }